import Quill from 'quill';

// const BlockEmbed = Quill.import('blots/block/embed');
const Embed = Quill.import('blots/embed');

class ImgBlot extends Embed {
  static create(attrs) {
    const { value, id } = attrs;
    const node = super.create(value);
    node.setAttribute('data-id', id);
    node.setAttribute('role', 'img-embed');
    // 禁止拖拽
    node.ondragstart = function (event) {
      event.preventDefault();
    };
    node.ondragover = function (event) {
      event.preventDefault();
    };
    // 禁止复制
    // node.addEventListener('copy', (e) => {
    //   navigator.clipboard.writeText('');
    //   e.preventDefault();
    // });

    node.contentEditable = 'false';
    node.innerText = value ?? '';
    return node;
  }

  static formats(node) {
    return {
      id: node.getAttribute('data-id'),
      value: node.innerText,
    };
  }
}

ImgBlot.blotName = 'DotImgEmbed';
ImgBlot.className = 'ql-img-embed-string';
ImgBlot.tagName = 'span';

export default ImgBlot;
